module.exports = __webpack_public_path__ + "img/2700m.e006b6d1.png";